// removed by extract-text-webpack-plugin
module.exports = {"ContainerWrapper":"_2iGAhbP5XMrnmC-hyIEExo","MainContent":"Cv40GNjFfbqQKRHx3hR26","LoaderWrapper":"_2_S3qLbY3xK82DKnYSX1vv"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 144
// module chunks = 0